import { render, staticRenderFns } from "./ActiveQuestions.vue?vue&type=template&id=18d21acd&scoped=true"
import script from "./ActiveQuestions.vue?vue&type=script&lang=js"
export * from "./ActiveQuestions.vue?vue&type=script&lang=js"
import style0 from "./ActiveQuestions.vue?vue&type=style&index=0&id=18d21acd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d21acd",
  null
  
)

export default component.exports